import { IconWrapper } from '../runtime';
export default IconWrapper('link_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
      "fill": "#6F7B84"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 18.375H24V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V18.375Z",
      "fill": "#5F6A72"
    }
  }), h("path", {
    "attrs": {
      "d": "M21 1.14742e-07C22.6569 1.87166e-07 24 1.34315 24 3L24 21.0968C24 22.7002 22.7002 24 21.0968 24C19.5936 24 18.375 22.7814 18.375 21.2782L18.375 0L21 1.14742e-07Z",
      "fill": "#8999A3"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.375 21.2782C18.375 22.7814 19.5936 24 21.0968 24C22.7002 24 24 22.7002 24 21.0968C24 19.5936 22.7814 18.375 21.2782 18.375H18.375V21.2782Z",
      "fill": "#6F7B84"
    }
  }), h("path", {
    "attrs": {
      "d": "M9.41492 4.49112C10.65 3.25361 12.6523 3.25361 13.8874 4.49112C15.1224 5.72864 15.1224 7.73507 13.8874 8.97259L11.8748 10.9889C10.6398 12.2264 8.63742 12.2264 7.4024 10.9889L8.73047 9.65813C9.23203 10.1607 10.0452 10.1607 10.5468 9.65813L12.5593 7.64179C13.0608 7.13924 13.0608 6.32446 12.5593 5.82192C12.0703 5.33192 11.285 5.31968 10.7812 5.7852C10.1013 5.43061 9.34465 5.27319 8.59506 5.31261L9.41492 4.49112Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M8.96221 13.8846C7.72717 15.1221 5.7248 15.1221 4.48976 13.8846C3.25473 12.647 3.25471 10.6407 4.4897 9.40314L6.50168 7.38678C7.73468 6.15132 9.73253 6.14922 10.9681 7.38059L9.63995 8.71139C9.13794 8.215 8.32938 8.21702 7.82987 8.71747L5.8179 10.7338C5.31636 11.2364 5.3163 12.0512 5.81784 12.5537C6.30855 13.0454 7.09757 13.0561 7.60118 12.5856C8.2852 12.938 9.04583 13.0916 9.79822 13.0467L8.96221 13.8846Z",
      "fill": "white"
    }
  })]);
});